export default {"src":"/_next/static/media/KIM.430a0f1b.svg","height":18,"width":18};